const state = {
    settings: {
        currency: '£',
        rows: {
            defaultunitofmeasure: ''
        },
        time: {
            units: [],
            baseunitoftime: 'Hours',
            hoursperday: 8,
            hoursperweek: 40
        },
        tax: {
            rate: 20
        },
        markup: {
            rate: 25
        },
        debug: {
            showJsonModels: false
        }
    },
};

// getters
const getters = {
    settings: state => state.settings, //all settings
};

// mutations
const mutations = {
    UPDATE_SETTINGS (state, settings) {
        console.log(settings)
        state.settings = settings
    },
    UPDATE_DEBUG(state, debug) {
        state.settings.debug.showJsonModels = debug
    }
};

// actions
const actions = {
    updateSettings ({ commit }, settings) {
        console.log(settings)
        commit('UPDATE_SETTINGS', settings)
    },
    updateDebug({commit}, debug){
        commit('UPDATE_DEBUG', debug)
    }
};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
